/* Step 13 · P5.1 (lane S13B) — EN + AR of the refusal when the same GL file is appended again to an FS head that already holds its
   lines (back end gl_headwise_dupes, error code HEADWISE_FILE_ALREADY_APPENDED). No standard paragraph is quoted. */
const I18N_S13P5_FIXES = {
  en: {
    errors: {
      HEADWISE_FILE_ALREADY_APPENDED: "This file has already been appended to the selected FS head(s); appending it again would count its lines twice. Use Replace to load it again, or leave those heads out.",
    },
  },
  ar: {
    errors: {
      HEADWISE_FILE_ALREADY_APPENDED: "سبق إلحاق هذا الملف إلى بند أو بنود القوائم المالية المختارة؛ وإلحاقه مرة أخرى يحتسب أسطره مرتين. استخدم «استبدال» لتحميله مجددًا، أو استبعد تلك البنود.",
    },
  },
};

export default I18N_S13P5_FIXES;
